/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
   FILE 2 — assets/ivoltaa-colors.js
   (used by sections/ivoltaa-colors.liquid)
   SAVE THIS AS A SEPARATE FILE in assets/
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */

function ivColorSelect(idx) {
  var swatches = document.querySelectorAll('.iv-colors-swatch');
  var labels   = document.querySelectorAll('.iv-colors-label');
  var imgs     = document.querySelectorAll('.iv-colors-img');
  var btn      = swatches[idx];
  if (!btn) return;

  var color = btn.dataset.color;
  var name  = btn.dataset.name;
  var url   = btn.dataset.url;

  imgs.forEach(function(img) { img.classList.remove('iv-colors-img--active'); });
  var target = document.getElementById('iv-cimg-' + idx);
  if (target) target.classList.add('iv-colors-img--active');

  swatches.forEach(function(s) { s.classList.remove('iv-colors-swatch--active'); });
  btn.classList.add('iv-colors-swatch--active');

  labels.forEach(function(l) { l.classList.remove('iv-colors-label--active'); l.style.color = ''; });
  var al = document.querySelector('.iv-colors-label[data-index="' + idx + '"]');
  if (al) { al.classList.add('iv-colors-label--active'); al.style.color = color; }

  var media  = document.getElementById('iv-colors-media');
  var rays   = document.getElementById('iv-colors-rays');
  var circle = document.getElementById('iv-colors-circle');
  var r1     = document.getElementById('iv-colors-ring1');
  var r2     = document.getElementById('iv-colors-ring2');
  var dot    = document.getElementById('iv-colors-pill-dot');
  var text   = document.getElementById('iv-colors-pill-text');
  var pill   = document.getElementById('iv-colors-pill');
  var dyn    = document.getElementById('iv-colors-dynamic');
  var cta    = document.getElementById('iv-colors-cta');
  var ctaTxt = document.getElementById('iv-colors-cta-text');

  if (media)  media.style.background  = 'radial-gradient(ellipse at 50% 60%,' + color + '18 0%,transparent 70%),linear-gradient(180deg,#0a1628 0%,' + color + '12 50%,#0a1628 100%)';
  if (rays)   rays.style.background   = 'conic-gradient(from 200deg at 50% 55%,transparent 0deg,' + color + '08 40deg,transparent 80deg,' + color + '06 160deg,transparent 200deg)';
  if (circle) { circle.style.background = 'radial-gradient(circle at 50% 45%,#ffffff 0%,#f0f4ff 40%,' + color + '22 68%,transparent 80%)'; circle.style.boxShadow = '0 0 0 1px ' + color + '33,0 0 60px ' + color + '30,inset 0 0 40px rgba(255,255,255,0.05)'; }
  if (r1)     r1.style.borderColor    = color + '20';
  if (r2)     r2.style.borderColor    = color + '10';
  if (dot)    { dot.style.background  = color; dot.style.boxShadow = '0 0 8px ' + color; }
  if (text)   text.textContent        = name;
  if (pill)   pill.style.borderColor  = color + '55';
  if (dyn)    dyn.style.color         = color;
  if (cta)    { cta.style.setProperty('--cc', color); if (url) cta.href = url; }
  if (ctaTxt) ctaTxt.textContent      = 'Shop ' + name + ' Cat6A';
}

document.addEventListener('DOMContentLoaded', function () {
  var first = document.querySelector('.iv-colors-swatch');
  if (!first) return;
  var c   = first.dataset.color || '#3B82F6';
  var dot = document.getElementById('iv-colors-pill-dot');
  var dyn = document.getElementById('iv-colors-dynamic');
  var cta = document.getElementById('iv-colors-cta');
  var circle = document.getElementById('iv-colors-circle');
  var media  = document.getElementById('iv-colors-media');
  var rays   = document.getElementById('iv-colors-rays');
  var r1     = document.getElementById('iv-colors-ring1');
  var r2     = document.getElementById('iv-colors-ring2');
  var fl     = document.querySelector('.iv-colors-label');
  if (media)  media.style.background  = 'radial-gradient(ellipse at 50% 60%,' + c + '18 0%,transparent 70%),linear-gradient(180deg,#0a1628 0%,' + c + '12 50%,#0a1628 100%)';
  if (rays)   rays.style.background   = 'conic-gradient(from 200deg at 50% 55%,transparent 0deg,' + c + '08 40deg,transparent 80deg,' + c + '06 160deg,transparent 200deg)';
  if (circle) { circle.style.background = 'radial-gradient(circle at 50% 45%,#ffffff 0%,#f0f4ff 40%,' + c + '22 68%,transparent 80%)'; circle.style.boxShadow = '0 0 0 1px ' + c + '33,0 0 60px ' + c + '30,inset 0 0 40px rgba(255,255,255,0.05)'; }
  if (r1)     r1.style.borderColor    = c + '20';
  if (r2)     r2.style.borderColor    = c + '10';
  if (dot)    { dot.style.background  = c; dot.style.boxShadow = '0 0 8px ' + c; }
  if (dyn)    dyn.style.color         = c;
  if (cta)    cta.style.setProperty('--cc', c);
  if (fl)     fl.style.color          = c;
});